import { Injectable } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { AuthService } from '../../_foundation/services/auth/auth.service';
import { App, Modal, ModalController } from 'ionic-angular';
import { LoginPage } from '../../pages/auth/login/login';
import { User } from '../../_foundation/models/security.models';
import { cloneDeep } from 'lodash';
import { ConfirmationModalComponent } from '../../pages/daily-log/confirmation-modal/confirmation-modal.component';

@Injectable()
export class IdleService {
  timedOut = false;
  expiryDate: Date;
  idleTimeSeconds: number = 3300; // number of seconds until idle warning popup appears
  timeoutTimeSeconds: number = 300; // number of seconds that the idle warning popup stays until logout
  private confirmationModal: Modal;

  public constructor(private idle: Idle,
                     private authService: AuthService,
                     public modalController: ModalController,
                     public app: App) {

    // sets an idle timeout.
    this.idle.setIdle(this.idleTimeSeconds);
    // sets a timeout period.
    this.idle.setTimeout(this.timeoutTimeSeconds);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      this.confirmationModal = this.modalController.create(ConfirmationModalComponent, {
        message: 'You are currently inactive. You will be logged out in: ',
        optionalMessage: 'Any unsaved work may be lost. Performing any action will cancel this timer.',
        title: 'Inactivity Warning',
        showButtons: false,
        idleTimer: this.timeoutTimeSeconds
      }, {cssClass: 'daily-log-modal-two-line'});

      this.confirmationModal.onDidDismiss(() => {
      });

      this.confirmationModal.present();
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.confirmationModal.dismiss();
      this.expiryDate = new Date();
      this.expiryDate.setSeconds(this.expiryDate.getSeconds() + this.timeoutTimeSeconds + this.idleTimeSeconds);
    });
    this.idle.onTimeout.subscribe(() => {
      this.handleTimeout().catch(error => console.error('Unable to complete automatic logout', error));
    });
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
    this.expiryDate = new Date();
    this.expiryDate.setSeconds(this.expiryDate.getSeconds() + this.timeoutTimeSeconds + this.idleTimeSeconds);
  }

  stopIdleTimer() {
    this.idle.stop();
  }

  private async handleTimeout() {
    const userId = cloneDeep(this.authService.currentUser<User>().id);

    await this.dismissOpenModals();

    this.timedOut = true;
    this.authService.logout();

    const rootNav = this.app.getRootNav();
    if (!rootNav) {
      throw new Error('Unable to find the root navigator for automatic logout');
    }

    await rootNav.push(LoginPage, {sessionTimeout: true, previousUser: userId});
  }

  private async dismissOpenModals() {
    const modalPortal = this.app && this.app._appRoot && this.app._appRoot._modalPortal;

    while (modalPortal && modalPortal.length() > 0) {
      const activeModal = modalPortal.getActive();

      if (!activeModal) {
        return;
      }

      try {
        await activeModal.dismiss();
      } catch {
        return;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/idle/idle.service.ts